import { FeatureFlag } from 'models/Config';
import useAppConfig from './useAppConfig';

export interface AllowedFlags {
  allowAutomationV3: boolean;
  allowPropertiesWebapp: boolean;
  allowPropertyEditV3Beta: boolean;
  allowOrderViewWebapp: boolean;
  allowChannelsV3: boolean;
  allowIntegrationsV3: boolean;
  allowCalendarPropertiesOptimization: boolean;
  allowSeasonalCancellationPolicies: boolean;
  allowDnsSecurity: boolean;
  allowDbsSettingsV3: boolean;
  allowAirbnbSeasonalCancellationPolicies: boolean;
  allowBcSeasonalCancellationPolicies: boolean;
  allowVrboSeasonalCancellationPolicies: boolean;
  allowHvmbSeasonalCancellationPolicies: boolean;
}

const useFeatures = (): AllowedFlags => {
  const { featureFlags } = useAppConfig();

  return {
    allowAutomationV3: featureFlags.includes(FeatureFlag.ALLOW_AUTOMATION_V3),
    allowPropertiesWebapp: !featureFlags.includes(
      FeatureFlag.ALLOW_PROPERTIES_WEBAPP,
    ),
    allowPropertyEditV3Beta: !featureFlags.includes(
      FeatureFlag.ALLOW_PROPERTY_EDIT_V3_BETA,
    ),
    allowOrderViewWebapp: !featureFlags.includes(
      FeatureFlag.ALLOW_ORDER_VIEW_WEBAPP,
    ),
    allowChannelsV3: !featureFlags.includes(FeatureFlag.ALLOW_CHANNELS_V3),
    allowIntegrationsV3: !featureFlags.includes(
      FeatureFlag.ALLOW_INTEGRATIONS_V3,
    ),
    allowCalendarPropertiesOptimization: featureFlags.includes(
      FeatureFlag.ALLOW_CALENDAR_PROPERTIES_OPTIMIZATION,
    ),
    allowSeasonalCancellationPolicies: featureFlags.includes(
      FeatureFlag.ALLOW_SEASONAL_CANCELLATION_POLICIES,
    ),
    allowDnsSecurity: featureFlags.includes(FeatureFlag.ALLOW_DNS_SECURITY),
    allowDbsSettingsV3: featureFlags.includes(
      FeatureFlag.ALLOW_DBS_SETTINGS_V3,
    ),
    allowAirbnbSeasonalCancellationPolicies: featureFlags.includes(
      FeatureFlag.ALLOW_AIRBNB_SEASONAL_CANCELLATION_POLICIES,
    ),
    allowBcSeasonalCancellationPolicies: featureFlags.includes(
      FeatureFlag.ALLOW_BC_SEASONAL_CANCELLATION_POLICIES,
    ),
    allowVrboSeasonalCancellationPolicies: featureFlags.includes(
      FeatureFlag.ALLOW_VRBO_SEASONAL_CANCELLATION_POLICIES,
    ),
    allowHvmbSeasonalCancellationPolicies: featureFlags.includes(
      FeatureFlag.ALLOW_HVMB_SEASONAL_CANCELLATION_POLICIES,
    ),
  };
};

export default useFeatures;
